import { render, staticRenderFns } from "./KkgNotificationCookies.vue?vue&type=template&id=ec3656aa&scoped=true"
import script from "./KkgNotificationCookies.vue?vue&type=script&lang=js"
export * from "./KkgNotificationCookies.vue?vue&type=script&lang=js"
import style0 from "./KkgNotificationCookies.vue?vue&type=style&index=0&id=ec3656aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3656aa",
  null
  
)

export default component.exports